import axiosInstance from 'api/axios';
import { APIResponse } from '../types';
import endpoints from '../textToSpeechEndpoints';

interface GenerateVoiceRequest {
  text: string;
  voice_name: string;
  emotion: string;
  is_celebrity: boolean;
}

export const ttsService = {
  // Generate voice from text
  generateVoice: async (
    data: GenerateVoiceRequest,
    signal?: AbortSignal
  ): Promise<APIResponse<string>> => {
    const response = await axiosInstance.private.post(
      endpoints.generateVoice,
      data,
      { signal }
    );
    return response.data;
  },

  // Get all available voices
  getAllVoices: async (
    signal?: AbortSignal
  ): Promise<
    APIResponse<{ name: string; url: string; voice: string; gender: string }[]>
  > => {
    const response = await axiosInstance.private.get(endpoints.getAllVoices, {
      signal,
    });
    return response.data;
  },
};
